import * as cn from 'classnames'
import * as styles from 'styles/pages/Styleguide.css'
import VerticalBarChart from 'components/features/pfm/VerticalBarChart/VerticalBarChart'
import HorizontalBarChart from 'components/features/pfm/HorizontalBarChart/HorizontalBarChart'
import CreditChart from 'components/features/pfm/CreditChart/CreditChart'
import { Caption } from 'components/atoms/Text'

const verticalBarChartProps = {
  values: { memberValue: 3556, peerValue: -1545, otherValue: 1200 },
  options: { isCurrency: true },
  othersName: 'National Avergage',
  withComparison: true,
}

const horizontalBarChartProps = {
  values: { memberValue: 5122, peerValue: 2235, otherValue: 421 },
  options: { isCurrency: true },
}
const creditChartProps = {
  memberValue: 725, peerValue: 680, otherValue: 42,
}

const SGCharts = () => (
  <section className={ cn(styles.sgSection, styles.sgCharts) }>
    <ul>
      <li>
        <VerticalBarChart { ...verticalBarChartProps } />
        <Caption text='Vertical Bar Chart' />
      </li>
      <li>
        <HorizontalBarChart { ...horizontalBarChartProps } />
        <Caption text='Horizontal Bar Chart' />
      </li>
      <li>
        <CreditChart { ...creditChartProps } />
        <Caption text='Credit Score Chart' />
      </li>
    </ul>
  </section>
)

export default SGCharts
